module.exports = __webpack_public_path__ + "static/green-wave-xs-1d68019a4588acc8611e69a2dc8b6498.png";